import { useEffect, useState } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Hero from "@/components/sections/Hero";
import Myths from "@/components/sections/Myths";
import Probiotics from "@/components/sections/Probiotics";
import Science from "@/components/sections/Science";
import Audience from "@/components/sections/Audience";
import LacLivePartner from "@/components/sections/LacLivePartner";
import Faq from "@/components/sections/Faq";
import Contact from "@/components/sections/Contact";
import api from "@/lib/api";

export default function Home() {
  const [content, setContent] = useState({ myths: [], faq: [], faq_categories: [] });

  useEffect(() => {
    api.get("/content/public").then(({ data }) => setContent(data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-[#F9F8F3]">
      <Navbar />
      <main>
        <Hero />
        <Myths myths={content.myths} />
        <Probiotics />
        <Science />
        <Audience />
        <LacLivePartner />
        <Faq faq={content.faq} categories={content.faq_categories} />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
